import script from "./WatchListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchListCard.vue?vue&type=script&setup=true&lang=js"

import "./WatchListCard.vue?vue&type=style&index=0&id=e2bafe2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2bafe2e"]])

export default __exports__